export default function platformAnimation(tl) {
  tl.from(".five-step-card", {
    stagger: 0.3,
    ease: "linear",
    duration: 0.3,
    scale: 0.6,
    opacity: 0,
  });
}
